export type EquipmentItem = {
    environment: string;
    shortcut: string;
};

export function getCheckEquipment(checkedItems: string[]) {
    if (checkedItems.length === 1 && checkedItems[0] === "no") return [];
    return checkedItems.map((item) => {
        return {
            environment: "home",
            shortcut: item,
        };
    });
}

export function equipmentFromAnswers(answers: EquipmentItem[]) {
    return answers.map((item) => item.shortcut);
}
